<template>
  <el-container class="workspace-page issue-rank-page">
    <el-main class="workspace-content table-scroll-area">
      <el-table :data="employees" height="500px" class="rank-table" style="width: 100%">
        <el-table-column prop="profilePicture" :label="$t('头像')" width="80">
          <template slot-scope="scope">
            <el-image :src="scope.row.profilePicture" fit="cover" style="width:40px; height:40px"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('姓名')" width="120" />
        <el-table-column :label="$t('权限')" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.roleId===100">{{ $t("超级管理员") }}</span>
            <span v-else-if="scope.row.roleId===1">{{ $t("企业管理员") }}</span>
            <span v-else>{{ $t("员工") }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="department.departmentName" :label="$t('部门')" width="150" />
        <el-table-column prop="issueCreated" :label="$t('创建问题')" sortable width="120" />
        <el-table-column prop="issueSolved" :label="$t('解决问题')" sortable width="120" />
        <el-table-column prop="issueVerified" :label="$t('验收问题')" sortable width="120" />
        <el-table-column prop="issueUnsolved" :label="$t('未解决')" sortable width="120" />
        <el-table-column prop="lastLoginRelativeTime" :label="$t('上次登录')" width="150" />
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import { t } from "@/i18n";
import axios from 'axios';
import app from '@/App';

export default {
  name: 'IssueRank',
  data() {
    return {
      user: {},
      employees: []
    };
  },
  created() {
    app.methods.getUser().then((res) => {
      this.user = res.data;
      if (this.user.roleId !== 100) {
        this.$message.error(t("无权访问"));
        this.$router.replace({ path: '/login' });
      } else {
        this.fetchEmployees();
      }
    });
  },
  methods: {
    fetchEmployees() {
      axios
        .get(process.env.VUE_APP_BASE_URL + '/users', {
          params: { orderBy: 'issueCount' }
        })
        .then((res) => {
          this.employees = res.data;
        })
        .catch(() => {
          this.$message.error(t("获取员工列表失败"));
        });
    }
  }
};
</script>

<style scoped>
.table-scroll-area {
  overflow-x: auto;
}

.rank-table {
  min-width: 980px;
}

@media (max-width: 900px) {
  .rank-table {
    min-width: 920px;
  }
}
</style>
